import React from 'react';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import VirtualAccountSetupsPicker from './VirtualAccountSetupsPicker';

const FacetPlanVirtualAccountSetupTemplate = () => {
  return (
    <>
      <TitleSection />
      <VirtualAccountSetupsPicker />
    </>
  );
};

export default FacetPlanVirtualAccountSetupTemplate;
